import { render } from "./GifttItem.vue?vue&type=template&id=420ca40e&scoped=true"
import script from "./GifttItem.vue?vue&type=script&lang=js"
export * from "./GifttItem.vue?vue&type=script&lang=js"

import "./GifttItem.vue?vue&type=style&index=0&id=420ca40e&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420ca40e"]])

export default __exports__